import { Box, Button, Typography } from "@material-ui/core";
import React from "react";
import LocalizedLink from "../../../../components/localized-link";
import { formatMultilinesText } from "../../../../helpers/markdown";
import {
  DEFAULT_SUBTITLE_FONT_SIZE,
  DEFAULT_TITLE_FONT_SIZE
} from "../../constants";
import {
  getLinkHref,
  getThemeColor,
  getThemeColorButtonVariant
} from "../../utils";
import BottomLeftContent from "../BottomLeftContent";

type Props = Queries.CardFragmentFragment;

export default function CardBottomLeftVariant(props: Props) {
  const ctaLinkHref = getLinkHref(props.ctaLink);
  return (
    <BottomLeftContent>
      <Box display="flex" width="100%" flexDirection="column">
        <Box marginBottom={{ xs: 1, md: 2 }} textAlign="left">
          {props.title && (
            <Typography
              variant={(props.titleFontSize as any) || DEFAULT_TITLE_FONT_SIZE}
              dangerouslySetInnerHTML={{
                __html: formatMultilinesText(props.title)
              }}
              style={{
                color: getThemeColor(props.titleTheme, "black")
              }}
            />
          )}
        </Box>
        {props.subtitle && props.subtitle && (
          <Typography
            variant={
              (props.subtitleFontSize as any) || DEFAULT_SUBTITLE_FONT_SIZE
            }
            dangerouslySetInnerHTML={{
              __html: props.subtitle
            }}
            style={{
              color: getThemeColor(props.subtitleTheme, "black")
            }}
          />
        )}
        {props.cta && ctaLinkHref && (
          <Button
            variant="contained"
            component={LocalizedLink}
            to={ctaLinkHref}
            title={props.cta}
            color={getThemeColorButtonVariant(props.ctaTheme, "yellow")}
            style={{ minWidth: "min(100%, 320px)" }}
          >
            {props.cta}
          </Button>
        )}
      </Box>
    </BottomLeftContent>
  );
}
